import { handleResponse } from "../../client";
import { resolveQueueTicketPrinterName } from "./printer";

const DRAWER_ENDPOINT = "http://localhost:55545/api/open-drawer";

/**
 * Open the cash drawer by calling the local agent endpoint.
 */
export async function openDrawer() {
  try {
    const res = await fetch(DRAWER_ENDPOINT, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        printer_name: resolveQueueTicketPrinterName(),
      }),
    });
    return await handleResponse(res);
  } catch (error) {
    console.warn("Failed to open cash drawer:", error);
  }
}
